var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloudProviderS3 = function SvgCloudProviderS3(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 428,
    height: 512,
    viewBox: "0 0 428 512",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e25444;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #7b1d13;\n      }\n\n      .cls-3 {\n        fill: #58150d;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M378,99L295,257l83,158,34-19V118Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378,99L212,118,127.5,257,212,396l166,19V99Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43,99L16,111V403l27,12L212,257Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.637,98.667l169.587,47.111V372.444L42.637,415.111V98.667Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M212.313,170.667l-72.008-11.556,72.008-81.778,71.83,81.778Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.143,159.111l-71.919,11.733-71.919-11.733V77.333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M212.313,342.222l-72.008,13.334,72.008,70.222,71.83-70.222Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212,16L140,54V159l72.224-20.333Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.224,196.444l-71.919,7.823V309.105l71.919,8.228V196.444Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.224,373.333L140.305,355.3V458.363L212.224,496V373.333Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.143,355.3l-71.919,18.038V496l71.919-37.637V355.3Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.224,196.444l71.919,7.823V309.105l-71.919,8.228V196.444Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212,16l72,38V159l-72-20V16Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloudProviderS3);
export { ForwardRef as ReactComponent };